<template>
  <div class="flex flex-shrink-0 flex-col w-full bg-[#F6F6F6] px-[4rem] py-[3rem] border-l border-[#E3E3E3]">
    <h4 class="text-[1.25re] leading-[1.5rem] font-[700] text-[#363636] text-center font-[ProximaNova] m-0">
      Change Current Plan
    </h4>

    <!--    <div class="w-full flex justify-center mt-[1.25rem]">-->
    <!--      <plan-select />-->
    <!--    </div>-->

    <div class="w-full inline-flex items-center justify-between mt-[1.875rem] pb-[1rem] border-b border-[#E3E3E3]">
      <b-form-group class="w-full !mb-[0]">
        <div class="flex items-center justify-between gap-[.625rem]">
          <span class="text-[.9375rem] text-[#202020] leading-[1.125rem] font-[400] font-[ProximaNova]">Plan</span>
          <span class="text-[.9375rem] text-[#202020] leading-[1.125rem] font-[400] font-[ProximaNova]">Price</span>
        </div>

        <hr class="border-t-[1px] border-[#D0D5DD] mt-[.5rem] mb-[1rem]">

        <b-form-radio-group
          v-model="currentPlan"
          class="flex flex-col gap-[.75rem]"
          @change="SET_PERIOD(currentPlan)"
        >
          <template #default>
            <div
              v-for="(item, index) in plans[0].duration"
              :key="index"
              class="inline-flex items-center justify-between gap-[.625rem]"
            >
              <b-form-radio
                :value="index"
                class="text-[.9375rem] text-[#464646] leading-[1.125rem] font-[500] font-[ProximaNova]"
                :class="[active.period === index ? 'text-[#000000]' : 'text-[#464646]']"
              >
                <div class="inline-flex items-center gap-[.25rem]">
                  {{ item.name }}
                </div>
              </b-form-radio>
              <span
                class="text-[.9375rem] text-[#464646] leading-[1.125rem] font-[500] font-[ProximaNova]"
                :class="[active.period === index ? 'text-[#000000]' : 'text-[#464646]']"
              >
                ${{ item.price }}/{{ item.interval === 'year' ? 'yr.' : 'mo.' }}
              </span>
            </div>
          </template>
        </b-form-radio-group>
      </b-form-group>
    </div>

    <purchase-plan-card-form 
      class="mt-[1.25rem]"
      :plan="plan"
      :active-plan="selectedPlan.id"
      @submit="onUpgrade"
    />
  </div>
</template>

<script>
import {mapActions, mapMutations, mapState} from 'vuex'
// import PlanSelect from '@/components/editor/modals/purchase-element/business-plus/controls/PlanSelect.vue'
import TextMixins from '@/components/mixins/TextMixins'
import PurchasePlanCardForm from '@/components/editor/modals/purchase-plan/PurchasePlanForm.vue'

export default {
  name: 'PurchasePlanUpgrade',
  components: {
    PurchasePlanCardForm
    // PlanSelect
  },
  mixins: [TextMixins],
  props: {
    plan: {
      type: Object,
      required: true
    },
    month: {
      type: Boolean,
      require: false
    },
    year: {
      type: Boolean,
      require: false
    }
  },
  data () {
    return {
      stripe: null,
      card: null,
      currentPlan: 0,
      paymentSuccess: false
    }
  },
  computed: {
    ...mapState('subscription', {
      active: state => state.active,
      plans: state => state.plans,
      premiumFeatures: state => state.premiumFeatures
    }),
    selectedPlan () {
      return this.plans[this.active.plan].duration[this.active.period]
    }
  },
  methods: {
    ...mapActions({
      changePlan: 'subscription/changePlan'
    }),
    ...mapMutations('subscription', {
      SET_PLAN: 'SET_PLAN',
      SET_PERIOD: 'SET_PERIOD'
    }),
    async onUpgrade ({payment_method, pm, setLoading}) {
      setLoading(true)
      let payload = {
        body: {
          plan: this.selectedPlan.code
        }
      }
      if (pm) {
        payload.pm = pm
      } else {
        payload.payment_method = payment_method
      }

      await this.changePlan(payload)
        .then(() => {
          this.paymentSuccess = true
          this.$emit('success')
        })
        .finally(() => {
          setLoading(false)
        })
    }
  },
  mounted () {
    if (this.year && !this.month) {
      this.active = 0
    } else if (this.month && !this.year) {
      this.active = 1
    }
  }
}
</script>